import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { client } from "../../App";
import { connect } from "react-redux";
import {
    setProducts,
    addProducts,
    setProductCount,
    setLastScrollPos
} from "../Redux/slices/productQuery";
import ProductGrid from "./ProductList/ProductGrid";
import { GET_PRODUCTS } from "../apollo";
import LoadMore from "./ProductList/LoadMore";
import { pageTransitionDuration } from "../Routes/MainRouter";

const mapStateToProps = state => {
    return {
        path: state.productQuery.currentQuery.path,
        products: state.productQuery.currentQuery.products,
        lastEdge: state.productQuery.currentQuery.lastEdge,
        count: state.productQuery.currentQuery.count,
        lastScrollPos: state.productQuery.currentQuery.lastScrollPos
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setProducts: payload => dispatch(setProducts(payload)),
        addProducts: payload => dispatch(addProducts(payload)),
        setProductCount: payload => dispatch(setProductCount(payload)),
        setLastScrollPos: payload => dispatch(setLastScrollPos(payload))
    }
}

class ProductList extends Component {
    constructor() {
        super();
        this.fetch = this.fetch.bind(this);
    }

    fetch() {
        // Unset last scroll pos
        this.props.setLastScrollPos({ scrollPos: null });

        // If user POPs back (e.g. from visiting a product)
        if (this.props.location.pathname === this.props.path && !this.props.queryVars.search) {
            return;
        }

        client.query({
            query: GET_PRODUCTS,
            variables: {
                first: this.props.perPage,
                ...this.props.queryVars
            }
        }).then(resp => {
            var lastCursor = resp.data.products.edges[resp.data.products.edges.length - 1];
            if (lastCursor) {
                lastCursor = lastCursor.cursor;
            }

            this.props.setProducts({
                path: this.props.location.pathname,
                products: resp.data.products.nodes,
                lastEdge: lastCursor
            });
            this.props.setProductCount({ total: resp.data.products.productCount });

            if (typeof this.props.resultsFallback === "function") {
                this.props.resultsFallback(resp.data.products.nodes.length);
            }

        }).catch(error => {
            console.error(error);
        });
    }

    componentDidMount() {
        this.fetch();
    }

    componentWillUnmount() {
        this.props.setLastScrollPos({ scrollPos: window.scrollY });
    }

    componentDidUpdate(prevProps) {
        if (this.props.queryVars.search && prevProps.queryVars.search !== this.props.queryVars.search) {
            this.props.setProducts({
                products: [],
                lastEdge: null
            });
            this.fetch();
        }
    }

    render() {
        var products = [];

        // If user POPs back (e.g. from visiting a product)
        if (this.props.location.pathname === this.props.path) {
            products = this.props.products;

            // Jump back to previous scroll position
            if (this.props.lastScrollPos) {
                setTimeout(() => {
                    window.scrollTo({ top: this.props.lastScrollPos });
                }, pageTransitionDuration);
            }
        }

        var loadMore = null;
        if (this.props.pagination !== false && products.length >= this.props.perPage) {
            loadMore = <LoadMore perPage={12} category={this.props.categoryId} search={this.props.search} queryVars={this.props.queryVars} productCount={products.length} />;
        }

        return <div className="product-list">
            <ProductGrid products={products} perPage={this.props.perPage || 12} />
            {loadMore}
        </div>
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductList));